"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableBody = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const body_html_1 = __importDefault(require("./body.html"));
const row_1 = require("./row");
const footer_totals_row_1 = require("./footer-totals-row");
let ItpDataTableBody = class ItpDataTableBody extends vue_1.default {
    model;
    columns;
    editable;
    noDeleteRow;
    noExpandableRowDetails;
    get columnCount() {
        return this.columns.length;
    }
    get rowGroupColspan() {
        return this.columnCount;
    }
    get hasRowDetails() {
        return !!this.$slots.rowDetails || !!this.$scopedSlots.rowDetails;
    }
    get rowDetailsLeadingOffset() {
        let offset = 0;
        if (this.model.options.rowSelection) {
            offset += 1;
        }
        if (this.model.options.rowHeader) {
            offset += 1;
        }
        return offset;
    }
    get rowDetailsTrailingOffset() {
        return 1;
    }
    get rowDetailsColspan() {
        return (this.columnCount -
            this.rowDetailsLeadingOffset -
            this.rowDetailsTrailingOffset);
    }
    get enableRowDetails() {
        return this.hasRowDetails && this.model.rowDetailsIsEnabled;
    }
    rowDetailsVisible(row) {
        return ((this.hasRowDetails && !!row['isExpanded']) ||
            this.model.rowDetailsIsAlwaysVisible);
    }
    get rowDetailsIsExpandable() {
        return this.model.options.rowDetailsMode === 'expandable';
    }
    isRowEditable(row) {
        return this.model.isRowEditable(row);
    }
};
exports.ItpDataTableBody = ItpDataTableBody;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpDataTableBody.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableBody.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableBody.prototype, "noDeleteRow", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableBody.prototype, "noExpandableRowDetails", void 0);
exports.ItpDataTableBody = ItpDataTableBody = __decorate([
    (0, vue_property_decorator_1.Component)({
        components: { ItpDataTableRow: row_1.ItpDataTableRow, ItpDataTableFooterTotalsRow: footer_totals_row_1.ItpDataTableFooterTotalsRow },
        template: body_html_1.default,
        inject: { model: 'model' }
    })
], ItpDataTableBody);
//# sourceMappingURL=body.js.map